<template>
<div class="mypage_common infoChange">
  <div class="common_head">
      <h5>회원정보변경</h5>
      <p>본인인증 후 회원정보를 직접 수정하실 수 있습니다.</p>
  </div>
  <div class="common_body">
      <div class="tbl_wrap">
          <table class="write type2">
              <tbody>
                  <tr>
                      <th>
                          이름
                      </th>
                      <td>
                          {{ accountInfo.name }}
                      </td>
                  </tr>
                  <tr>
                      <th>
                          아이디
                      </th>
                      <td>
                          {{ accountInfo.username }}
                      </td>
                  </tr>
                  <tr>
                      <th>
                          생년월일
                      </th>
                      <td>
                          {{ accountInfo.birthday }}
                      </td>
                  </tr>
                  <tr>
                      <th>
                          주소
                      </th>
                      <td>
                          <div class="wrapper">
                              <div class="input_wrap">
                                  <input type="text" class="address" v-model="accountInfo.zonecode" disabled>
                                  <button class="srch_address" @click="openPostcode">우편번호 검색</button>
                              </div>
                          </div>
                          <div class="wrapper">
                              <div class="input_wrap">
                                  <input type="text" class="address2" v-model="accountInfo.roadAddress">
                                  <input type="text" class="address" v-model="accountInfo.detailAddress">
                              </div>
                          </div>
                          <span class="phrase">* 이벤트, 경품 당첨 시 기본 배송지로 전달 됩니다.</span>
                      </td>
                  </tr>
                  <tr>
                      <th>
                          <span>*</span>전화번호
                      </th>
                      <td>
                          <div class="wrapper">
                              <input type="text" class="num" v-model="telNum.first">
                              <span>-</span>
                              <input type="text" class="num" v-model="telNum.mid">
                              <span>-</span>
                              <input type="text" class="num" v-model="telNum.last">
                          </div>
                      </td>
                  </tr>
                  <tr>
                      <th>
                          휴대폰
                      </th>
                      <td>
                          <div class="wrapper">
                              <input type="text" class="num" v-model="phoneNum.first">
                              <span>-</span>
                              <input type="text" class="num" v-model="phoneNum.mid">
                              <span>-</span>
                              <input type="text" class="num" v-model="phoneNum.last">
                          </div>
                      </td>
                  </tr>
                  <tr>
                      <th>
                          <span>*</span>이메일
                      </th>
                      <td>
                          <div class="wrapper">
                              <input type="text" class="mail" v-model="email.emailFirst">
                              <span>@</span>
                              <input type="text" class="mail" v-model="email.emailLast" :disabled="emailSelf !== '직접입력'">
                              <SelectList v-model="emailSelf" :options="emailOptions" unit="" selectClass="select_box mail"/>
                          </div>
                      </td>
                  </tr>
                  <tr>
                      <th>
                          <span>*</span>문자수신동의
                      </th>
                      <td>
                          <div class="wrapper">
                              <label for="agree01" class="radio_wrap">
                                <input type="radio" :true-value="'Y'" :false-value="'N'" :value="'Y'" v-model="accountInfo.marketingSms" @click="toggleRadio('sms')">
                                  <span>동의함</span>
                              </label>
                              <label for="disagree01" class="radio_wrap">
                                <input type="radio" :true-value="'Y'" :false-value="'N'" :value="'N'" v-model="accountInfo.marketingSms" @click="toggleRadio('sms')">
                                  <span>동의하지않음</span>
                              </label>
                          </div>
                      </td>
                  </tr>
                  <tr>
                      <th>
                          <span>*</span>이메일수신동의
                      </th>
                      <td>
                          <div class="wrapper">
                              <label for="agree02" class="radio_wrap">
                                <input type="radio" :true-value="'Y'" :false-value="'N'" :value="'Y'" v-model="accountInfo.marketingEmail" @click="toggleRadio('email')">
                                  <span>동의함</span>
                              </label>
                              <label for="disagree02" class="radio_wrap">
                                <input type="radio" :true-value="'Y'" :false-value="'N'" :value="'N'" v-model="accountInfo.marketingEmail" @click="toggleRadio('email')">
                                  <span>동의하지않음</span>
                              </label>
                          </div>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
      <ul class="infoChange_txt">
          <li><span>·</span> 문자 수신 / 메일 수신에 동의 하시면 이벤트 정보, 상품 정보 기타 다양한 정보를 보다 빠르게 만나실 수 있습니다.</li>
      </ul>
      <div class="btn_wrap">
          <button type="button" class="btn_cancel" @click="$router.push({ name: 'MyPage' })">취소</button>
          <button type="button" class="btn_check" @click="saveAccountInfo">확인</button>
      </div>
  </div>
</div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import SelectList from '@/components/common/SelectList.vue';

const accountModule = 'accountModule'

export default {
  components: {
    SelectList
  },

  data () {
    return {
      currentPage: 1,
      accountInfo: {
      },
      telNum: {
        first: '',
        mid: '',
        last: ''
      },
      phoneNum: {
        first: '',
        mid: '',
        last: ''
      },
      email: {
        emailFirst: '',
        emailLast: ''
      },
      emailSelf: '직접입력',
      emailOptions: [
        '직접입력',
        'naver.com',
        'gmail.com'
      ],
    }
  },

  methods: {
    ...mapActions(accountModule, [
        'requestAccountInfo',
        'requestChangeAccountInfo'
    ]),

    openPostcode() {
      new window.daum.Postcode({
        oncomplete: (data) => {
          this.accountInfo.zonecode = data.zonecode;
          this.accountInfo.roadAddress = data.roadAddress;
        }
      }).open()
    },

    toggleRadio(type) {
        switch(type) {
            case 'sms' :
                if (this.accountInfo.marketingSms === 'Y') this.accountInfo.marketingSms = 'N'
                else this.accountInfo.marketingSms = 'Y'
                break;
            
            case 'email':
                if (this.accountInfo.marketingEmail === 'Y') this.accountInfo.marketingEmail = 'N'
                else this.accountInfo.marketingEmail = 'Y'
                break;
        }
    },

    filterPhoneAndEmail() {
        const splitPhoneNumber = (number) => {
            if (!number) return { first: '', mid: '', last: '' };

            if (number.length === 11) {
                return {
                    first: number.slice(0, 3),
                    mid: number.slice(3, 7),
                    last: number.slice(7)
                };
            }
        
            if (number.length === 10) {
            if (number.startsWith('02')) {
                return {
                    first: number.slice(0, 2),
                    mid: number.slice(2, 6),
                    last: number.slice(6)
                };
            } else {
                    return {
                        first: number.slice(0, 3),
                        mid: number.slice(3, 6),
                        last: number.slice(6)
                    };
                }
            }

            return { first: '', mid: '', last: '' };
        };

        this.telNum = splitPhoneNumber(this.accountInfo.telNum);
        this.phoneNum = splitPhoneNumber(this.accountInfo.phoneNum);

        const emailParts = this.accountInfo.email.split('@');
        this.email = {
          emailFirst: emailParts[0] || '',
          emailLast: emailParts[1] || ''
        };
        if (this.email.emailLast === 'gmail.com' || this.email.emailLast === 'naver.com') {
            this.emailSelf = this.email.emailLast
        }
    },

    async saveAccountInfo () {
        const isValid = this.validation()
        if (isValid) {
            this.$openModal('alertModal', {
                message: isValid
            })
            return
        }

        this.accountInfo.telNum = this.telNum.first + this.telNum.mid + this.telNum.last
        this.accountInfo.phoneNum = this.phoneNum.first + this.phoneNum.mid + this.phoneNum.last
        this.accountInfo.email = this.email.emailFirst + '@' + this.email.emailLast
        const result = await this.requestChangeAccountInfo(this.accountInfo)
        this.$openModal('alertModal', {
            message: result
        })
    },

    validation() {
      if (this.phoneNum.first.length < 1 || this.phoneNum.mid.length < 1 || this.phoneNum.last.length < 1 ) return '휴대폰 번호를 입력해 주세요'
      if (this.telNum.first.length < 1 || this.telNum.mid.length < 1 || this.telNum.last.length < 1 ) return '휴대폰 번호를 입력해 주세요'
      if (this.email.emailFirst.length < 1 || this.email.emailLast.length < 1) return '이메일을 입력해 주세요'
      else return ''
    },
  },

  async mounted() {
    this.accountInfo = await this.requestAccountInfo()
    await this.filterPhoneAndEmail()
  },

  watch: {
    emailSelf: {
        handler(newVal) {
            if (newVal !== '직접입력') {
                this.email.emailLast = newVal
            } else {
                this.email.emailLast = ''
            }
        }
    },
  }
}
</script>